import React from "react";
import PropTypes from "prop-types";
import CustomerActionRow from "../components/CustomerActionRow";

const Customer = ({
  name,
  code,
  address,
  phone,
  email,
  id,
  openedId,
  setOpened,
  customerAction,
  labelBasic,
  labelSpecial,
  labelClaim,
  labelWarehouse,
  labelCommission,
  openOrders,
  getCustomerCart,
  isCartLoading,
  shippingAddress,
  openDualCart,
  isSpecialCart
}) => (
  <div className="row">
    <div className="col">
      <div className="customer-row" onClick={e => setOpened(id, e)}>
        <div className="row">
          <div className="col-12 col-md-3 customer-name">{name}</div>
          {openedId !== id && (
            <div className="col-12 col-md-8">
              <div className="row">
                <div className="col-12 col-md-2 customer-name">{code}</div>
                <div className="col-12 col-md-2 customer-action">{phone}</div>
                <div className="col-12 col-md-2 customer-action">{email}</div>
                <div className="col-12 col-md-3 customer-action">{address}</div>
                <div className="col-12 col-md-3 customer-action">
                  {shippingAddress}
                </div>
              </div>
            </div>
          )}
          {openedId === id && (
            <div className="col-12 col-md-8 customer-action">
              <CustomerActionRow
                customerAction={customerAction}
                openOrders={openOrders}
                labelBasic={labelBasic}
                labelSpecial={labelSpecial}
                labelClaim={labelClaim}
                labelWarehouse={labelWarehouse}
                labelCommission={labelCommission}
                openDualCart={openDualCart}
                isSpecialCart={isSpecialCart}
              />
            </div>
          )}
          {openOrders && openOrders.basic == "user" && (
            <div className="col-12 col-md-1">
              <button
                className="client-open-cart"
                onClick={e => {
                  console.log("open OO modal");
                  getCustomerCart();
                  e.stopPropagation();
                }}
              >
                {
                  <i
                    className={`fa ${!isCartLoading ? "fa-cart-arrow-down" : "fa-refresh"
                      }`}
                    title="Klientská objednávka"
                  />
                }
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  </div>
);

Customer.propTypes = {
  name: PropTypes.string,
  address: PropTypes.string,
  phone: PropTypes.string,
  id: PropTypes.number,
  code: PropTypes.string,
  openedId: PropTypes.number,
  customerAction: PropTypes.func,
  setOpened: PropTypes.func,
  labelBasic: PropTypes.string,
  labelSpecial: PropTypes.string,
  labelClaim: PropTypes.string,
  labelWarehouse: PropTypes.string,
  labelCommission: PropTypes.string,
  openOrders: PropTypes.array,
  openDualCart: PropTypes.func,
  isSpecialCart: PropTypes.bool
};

export default Customer;



// WEBPACK FOOTER //
// ./src/routes/CustomerList/components/Customer.js